<template>
  <div v-if="(isRatingComparison && isSpecialRatingCompared)
         || (itemValue && itemValue !== '0') || isSelectedRating || (itemValue === '0' && !isRatingModal)"
       class="flex items-center gap-2 p-2.5 border-zt-light transition-opacity"
       :class="[
         { 'gap-2.5': isRatingModal || isRatingComparison || isFunctionalityRatings },
         { 'mb-3': isRatingModal },
         { 'w-[305px]': isBookieRankingItem && window.size.desktop },
         { 'w-[355px]': isRatingComparison && window.size.desktop },
         { 'border-zt-more': (isRatingModal || isFunctionalityRatings) && shouldAddBorder },
         { 'cursor-pointer zt-hover hover:opacity-60':
           !(isPromoCodeDetails && window.size.mobile) && (!isRatingModal || (isRatingModal && (shouldRedirect || shouldOpenSecondOrderModal))) && showHover },
         isPromoCodeDetails
           ? 'bg-zt-normal border-t last-of-type:border-b cursor-pointer hover:bg-zt-light/35 pb-3.5 xl:pb-2.5 xl:bg-zt-light/35 xl:border xl:rounded-zt'
           : 'bg-zt-light/35 border rounded-zt'
       ]"
       @click="handleClick">
    <div class="text-sm font-semibold text-center rounded-zt"
         :class="isRatingModal && (isBookmakerRankingPage && isBookieAllRatingsModal) && !isFunctionalityRatings && !showIcons
           ? 'border border-zt-light h-[25px] w-[25px]'
           : 'flex justify-center items-center h-[30px] w-[30px]'">
      <span v-if="isRatingModal && (isBookmakerRankingPage && isBookieAllRatingsModal) && !showIcons">{{ index }}</span>
      <div v-else-if="isFunctionalityRatings || isRatingComparison || (isRatingModal && promoUrl)"
           class="w-full h-full bg-cover"
           :style="{ backgroundImage: `url('/wp-content/themes/zawodtyper/assets/images/bukmacherzy/logo_${ itemLogo.replaceAll(' ', '') + '_kod_promocyjny.svg' }` }"></div>
      <div v-else
           class="w-[70%] h-[70%] bg-contain bg-no-repeat bg-center" 
           :style="{ backgroundImage: `url('/wp-content/themes/zawodtyper/assets/images/ikony_funkcjonalnosci/${itemLogo}.svg`}"></div>
    </div>
    <div class="flex-1 flex flex-col items-center w-full truncate">
      <div class="flex justify-between items-center gap-2 w-full h-6 mb-1.5 truncate">
        <div class="flex items-center gap-[7px] truncate">
          <span class="tracking-[0.03em] leading-[27px] text-sm truncate">
            {{ itemName }}
          </span>
          <svg class="min-w-[13px] min-h-[10px]"
               :class="shouldRedirect || shouldOpenSecondOrderModal ? 'block' : 'hidden'"
               width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M 8.4 10 L 13 5 L 8.4 0 L 7.7 0.8 L 11 4.4 L 2.6 4.4 V 5.6 L 11 5.6 L 7.7 9.2 L 8.4 10 Z" fill="white" />
            <path d="M 1.1 4.4 H 0 L 0 5.6 H 1.1 L 1.1 4.4 Z" fill="white" />
          </svg>
        </div>
        <div>
          <svg v-if="Number(itemValue) === 11 || (typeof itemValue === 'boolean' && itemValue)" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_3847_1043)">
              <path d="M14.5501 6.81531C9.8278 6.81531 6 10.6433 6 15.3654C6 20.0872 9.8278 23.9156 14.5501 23.9156C19.272 23.9156 23.1001 20.0872 23.1001 15.3654C23.1001 10.6433 19.2719 6.81531 14.5501 6.81531ZM14.5501 22.7065C10.4956 22.7065 7.20891 19.4197 7.20891 15.3654C7.20891 11.311 10.4956 8.02447 14.5501 8.02447C18.6042 8.02447 21.891 11.3111 21.891 15.3654C21.891 19.4197 18.6042 22.7065 14.5501 22.7065Z" fill="#84EC00" />
            </g>
            <path d="M21.2277 15.2499C21.2277 18.9025 18.2665 21.8634 14.6139 21.8634C10.961 21.8634 8 18.9025 8 15.2499C8 11.5971 10.961 8.63586 14.6139 8.63586C18.2665 8.63586 21.2277 11.5971 21.2277 15.2499Z" fill="#84EC00" />
            <path d="M17.4506 19.893L14.5496 18.3677L11.6488 19.8925L12.2026 16.6625L9.85547 14.3754L13.0993 13.9041L14.5494 10.9655L16 13.9041L19.2431 14.3754L16.8961 16.6625L17.4506 19.893Z" fill="#2F3B4E" />
          </svg>
        </div>
        <span v-if="Number(itemValue) < 11 && Number(itemValue) > 0 && (typeof itemValue !== 'boolean')"
              class="text-xs font-normal">{{ itemValue }}/10</span>
        <div v-if="itemValue === '' || Number(itemValue) === 0">
          <p class="px-[7px] py-[1px] bg-[#533447] border-[#FF522C] border-[0.5px] text-xs rounded-[5px]">brak</p>
        </div>
      </div>
      <div class="w-full h-[9px] rounded-full relative" :style="[getBarBackgroundColor(itemValue)]">
        <Transition appear name="fill">
          <div v-if="isVisible"
               class="absolute top-0 left-0 h-[9px] rounded-full"
               :style="[{ width: getBarWidth(itemValue) + '%' }, getBarColor(itemValue)]"></div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../mixins/utils_mixin';
import { countClicks } from '../../assets/js/utils';

export default {
  name: 'BookmakerRatingItem',
  inject: ['WP'],
  emits: ['open-modal'],
  props: {
    item: Object,
    index: Number,
    isRatingModal: Boolean,
    isSelectedRating: Boolean,
    isBookieAllRatingsModal: Boolean,
    isBookieRankingItem: Boolean,
    isRatingComparison: Boolean,
    isSecondBookie: Boolean,
    isSecondOrderModal: Boolean,
    isFunctionalityRatings: Boolean,
    isRankingItemShortcode: Boolean,
    isPromoCodeDetails: Boolean,
    bookmakerName: String,
    functionalityName: String,
    bookieWithBorder: String,
	  showIcons: {
			type: Boolean,
		  default: false
	  },
    analyticName: {
      type: String,
      default: ''
    },
    showHover: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isVisible: false,
      promoUrl: ''
    };
  },
  mounted() {
    if (this.item.name) {
      this.promoUrl = utils_mixin.methods.getBookiePromoLink(this.item.name);
    }
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.75,
        rootMargin: '0px 0px 0px 0px'
      }
    );
    if (this.$el.data != 'v-if') {
      setTimeout(() => observer.observe(this.$el), 300);
    }
  },
  computed: {
    itemValue() {
      if (this.isSecondBookie) {
        return this.item.value2;
      } else {
        return this.item.value;
      }
    },
    itemName() {
      if (this.item.name === 'sts') {
        return 'STS';
      } else if (this.item.name === 'goplusbet') {
        return 'GoPlusBet';
      } else if (this.item.name === 'betx') {
        return 'BetX';
      } else if (this.item.name === 'betcris') {
        return 'BetCris';
      } else if (this.item.name === 'lvbet') {
        return 'LVBet';
      } else if (this.isRatingComparison && !this.isBookieAllRatingsModal && window.size.mobile) {
        return this.bookmakerName;
      } else {
        return this.item.name.charAt(0).toUpperCase() + this.item.name.slice(1);
      }
    },
    itemLogo() {
      if (this.isRatingComparison && !this.isBookieAllRatingsModal) {
        return this.bookmakerName.toLowerCase();
      } else {
        const itemName = this.item.name.toLowerCase()
          .replace(/\s/g, '_')
          .replace(/[ąćęłńóśżź/]/g, match => ({
            'ą': 'a',
            'ć': 'c',
            'ę': 'e',
            'ł': 'l',
            'ń': 'n',
            'ó': 'o',
            'ś': 's',
            'ż': 'z',
            'ź': 'z',
            '/': '_'
          }[match]))
          .replace(/fame_mma|clout_mma|prime_show_mma/g, 'federacje');

        return itemName;
      }
    },
    shouldRedirect() {
      if ((this.promoUrl === window.location.pathname && this.isRatingModal)
        || (this.isBookieAllRatingsModal && this.isBookmakerRankingPage) || this.functionalityName) {
        return false;
      } else {
        return true;
      }
    },
    shouldOpenSecondOrderModal() {
      if (this.isBookieAllRatingsModal && !this.isFunctionalityRatings && !this.isBookmakerRankingPage) {
        return true;
      } else {
        return false;
      }
    },
    shouldAddBorder() {
      if ((!this.isFunctionalityRatings && this.bookmakerName.toLowerCase() === this.itemName.toLowerCase())
        || (this.bookieWithBorder && this.bookieWithBorder.toLowerCase() === this.itemName.toLowerCase())
        || (this.functionalityName && this.functionalityName.toLowerCase() === this.itemName.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    isBookmakerRankingPage() {
      if (window.location.pathname === '/ranking-bukmacherow/') {
        return true;
      } else {
        return false;
      }
    },
    isSpecialRatingCompared() {
      return (typeof this.item.value === 'boolean' || typeof this.item.value2 === 'boolean')
        && (this.item.value || this.item.value2);
    },
    isSelectedPromoCodePost() {
      // Kody promo: Betfan, Betcris, LVBet, STS, Totalbet 
      if (this.WP.id === 22064 ||  this.WP.id === 24821 || this.WP.id === 665 || this.WP.id === 17074 || this.WP.id === 10533) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    getBarBackgroundColor(value) {
      let val = typeof value === 'boolean' && value ? 11 : Number(value);
      if (val > 6) {
        return 'background: linear-gradient(270deg, rgba(47, 234, 122, 0.2), rgba(144, 221, 83, 0.2));';
      } else if (val > 4) {
        return 'background: linear-gradient(270deg, rgba(47, 234, 155, 0.2), rgba(127, 221, 83, 0.2));';
      } else if (val > 2) {
        return 'background: linear-gradient(270deg, rgba(255, 191, 26, 0.2), rgba(255, 64, 128, 0.2));';
      } else if (val > 0) {
        return 'background: linear-gradient(270deg, rgba(255, 81, 26, 0.2), rgba(255, 64, 128, 0.2));';
      } else {
        return 'background: linear-gradient(270deg, rgba(255, 67, 26, 0.2), rgba(255, 64, 128, 0.2));';
      }
    },
    getBarColor(value) {
      let val = typeof value === 'boolean' && value ? 11 : Number(value);
      if (val > 7) {
        return 'background: linear-gradient(270deg, rgba(47, 234, 122, 1), rgba(144, 221, 83, 1));';
      } else if (val > 6) {
        return 'background: linear-gradient(270deg, rgba(47, 234, 155, 1), rgba(127, 221, 83, 1));';
      } else if (val > 4) {
        return 'background: linear-gradient(270deg, rgba(208, 234, 47, 1), rgba(160, 221, 83, 1));';
      } else if (val > 2) {
        return 'background: linear-gradient(270deg, rgba(255, 191, 26, 1), rgba(255, 64, 128, 1));';
      } else if (val > 0) {
        return 'background: linear-gradient(270deg, rgba(255, 81, 26, 1), rgba(255, 64, 128, 1));';
      } else {
        return 'background: linear-gradient(270deg, rgba(255, 67, 26, 0.2), rgba(255, 64, 128, 0.2));';
      }
    },
    getBarWidth(value) {
      let val = typeof value === 'boolean' && value ? 11 : Number(value);
      if (val === 11) {
        return 100;
      } else {
        return val * 10;
      }
    },
    openModal() {
      this.$emit('open-modal', this.item.name, this.bookmakerName);
    },
    handleCount(name, isRatingModal) {
      let analyticsText = '';

      if (name === 'Fortuna' || name === 'Betclic') {
        analyticsText = isRatingModal ? 'modale klikalne' : 'wyskakujące klikalne';
      }

      if (analyticsText) {
        const message = `Kod promo ${name} ${analyticsText}`;
        countClicks(message);
      }
    },
    handleClick() {
      if (this.analyticName) {
        countClicks(this.analyticName);
      }
      if ((this.isRatingModal && this.shouldOpenSecondOrderModal) || !this.isRatingModal) {
        this.openModal();
        if (this.isFunctionalityRatings && !this.analyticName) {
          countClicks('Funkcjonalności - shortcode czwarty rodzaj przed modalem');
        } else if (this.isRankingItemShortcode && !this.analyticName) {
          countClicks('Funkcjonalności - shortcode trzeci rodzaj przed modalem');
        } else if (this.isPromoCodeDetails && !this.analyticName) {
          countClicks('Kod promo Fortuna - analityka 1: FUNKCJONALNOŚCI BUKMACHERA');
        }
      }
      if (this.isBookieRankingItem && !this.analyticName) {
        countClicks('Ranking bukmacherów [funkcjonalności+rozwiń+wyświetl wszystkie]');
      }
      if (this.bookmakerName === 'Fortuna' || this.bookmakerName === 'Betclic') {
        this.handleCount(this.bookmakerName, this.isRatingModal);
      }
      if (this.isRatingModal && !this.isBookieAllRatingsModal && !this.isFunctionalityRatings) {
        utils_mixin.methods.redirectToPromoPage(this.promoUrl, this.shouldRedirect);
      }
    }
  }
};
</script>
<style scoped>
.fill-enter-active,
.fill-leave-active {
  transition: transform 0.5s ease;
  transform-origin: center left;
}

.fill-enter-from,
.fill-leave-to {
  transform: scaleX(0);
}

.fill-enter-to,
.fill-leave-from {
  transform: scaleX(1);
}
</style>
